import service from "@/utils/request";
// 数据统计-教务数据统计
export interface getEducationalTotalData {
  time_tag: string;
  start_date: string;
  end_date: string;
  teacher_id?: number;
  course_type?: number;
}
export const getEducationalTotalApi = (params: getEducationalTotalData) => {
  return service({
    url: "/api/v1/statistics/educational_data",
    method: "get",
    params,
  });
};
// 数据统计-教务数据列表
export interface getEducationalListData {
  time_tag: string;
  start_date: string;
  end_date: string;
  teacher_id?: number;
  course_type?: number;
}
export const getEducationalListApi = (params: getEducationalListData) => {
  return service({
    url: "/api/v1/statistics/educational_list",
    method: "get",
    params,
  });
};
// 数据统计-推送设置详情
export const getPushSetting = () => {
  return service({
    url: "/api/v1/statistics/push_setting/detail",
    method: "get",
  });
};
// 数据统计-推送设置
export interface setPushSettingData {
  push_time: string;
  staff_ids: number[];
}
export const setPushSettingApi = (data: setPushSettingData) => {
  return service({
    url: "/api/v1/statistics/push_setting/set",
    method: "post",
    data,
  });
};
export interface getCourseIncomeData {
  start_date: string;
  end_date: string;
  subject_id?: number;
  course_type?: number;
}
// 数据统计-课程收入列表(明细)
export const getCourseIncomeDetailApi = (params: getCourseIncomeData) => {
  return service({
    url: "/api/v1/statistics/course_income_detail",
    method: "get",
    params,
  });
};
// 数据统计-课程收入列表(汇总)
export const getCourseIncomeListApi = (params: {
  start_date: string;
  end_date: string;
}) => {
  return service({
    url: "/api/v1/statistics/course_income_list",
    method: "get",
    params,
  });
};
// 数据统计-课后练习数据
export interface getHomeworkListData {
  start_date: string;
  end_date: string;
}
// 数据统计-课后练习列表
export const getHomeworkListApi = (params: getHomeworkListData) => {
  return service({
    url: "/api/v1/statistics/homework_list",
    method: "get",
    params,
  });
};
// 数据统计-课后练习统计
export const getHomeworkDataApi = (params: getHomeworkListData) => {
  return service({
    url: "/api/v1/statistics/homework_data",
    method: "get",
    params,
  });
};
// 数据统计-教师练习统计列表
export const getHomeworkTeacherListApi = (params: getHomeworkListData) => {
  return service({
    url: "/api/v1/statistics/homework/teacher_list",
    method: "get",
    params,
  });
};
// 体验课统计数据
export interface statisticsExperienceDataInter {
  start_date: string;
  end_date: string;
  time_tag: string;
}
export const statisticsExperienceDataApi = (
  params: statisticsExperienceDataInter
) => {
  return service({
    url: "/api/v1/statistics/experience_data",
    method: "get",
    params,
  });
};
export interface experienceFollowStaffListInter {
  start_date: string;
  end_date: string;
  main_course_type?: number;
  follow_staff_id?: number;
  staff_status?: number;
}

// 课程顾问体验数据统计列表
export const experienceFollowStaffListApi = (
  params: experienceFollowStaffListInter
) => {
  return service({
    url: "/api/v1/statistics/experience/follow_staff_list",
    method: "get",
    params,
  });
};
export interface experienceTeacherListInter {
  start_date: string;
  end_date: string;
  main_course_type?: number;
  teacher_id?: number;
  staff_status?: number;
}
// 教师体验数据统计列表
export const experienceTeacherListApi = (
  params: experienceTeacherListInter
) => {
  return service({
    url: "/api/v1/statistics/experience/teacher_list",
    method: "get",
    params,
  });
};
export interface experienceAppearListInter {
  start_date: string;
  end_date: string;
  main_course_type?: number;
  appear_id?: number;
}
// 体验数据统计列表-出现方式
export const experienceAppearListApi = (params: experienceAppearListInter) => {
  return service({
    url: "/api/v1/statistics/experience/appear_list",
    method: "get",
    params,
  });
};
export interface experienceSourceListInter {
  start_date: string;
  end_date: string;
  main_course_type?: number;
  source_id?: number;
}
// 来源渠道体验数据统计列表
export const experienceSourceListApi = (params: experienceSourceListInter) => {
  return service({
    url: "/api/v1/statistics/experience/source_list",
    method: "get",
    params,
  });
};
export interface experienceCourseListInter {
  start_date: string;
  end_date: string;
  main_course_type?: number;
  course_id?: number;
  course_type?: number;
  subject_id?: number;
}
// 来源渠道体验数据统计列表
export const experienceCourseListApi = (params: experienceCourseListInter) => {
  return service({
    url: "/api/v1/statistics/experience/course_list",
    method: "get",
    params,
  });
};
// 数据统计-续费数据-课程续费数据统计
export interface courseRenewDataInter {
  start_date: string;
  end_date: string;
  time_tag: string;
}
export const courseRenewDataApi = (params: courseRenewDataInter) => {
  return service({
    url: "/api/v1/statistics/course_renew_data",
    method: "get",
    params,
  });
};
// 数据统计-续费数据-课程顾问续费统计列表
export interface renewFollowStaffListInter {
  start_date: string;
  end_date: string;
}
export const renewFollowStaffListApi = (params: renewFollowStaffListInter) => {
  return service({
    url: "/api/v1/statistics/course_renew/follow_staff_list",
    method: "get",
    params,
  });
};
// 数据统计-续费数据-教务老师续费统计列表
export interface renewEduTeacherListInter {
  start_date: string;
  end_date: string;
}
export const renewEduTeacherListApi = (params: renewEduTeacherListInter) => {
  return service({
    url: "/api/v1/statistics/course_renew/edu_teacher_list",
    method: "get",
    params,
  });
};
// 数据统计-续费数据-授课教师续费统计列表
export interface renewTeacherListInter {
  start_date: string;
  end_date: string;
}
export const renewTeacherListApi = (params: renewTeacherListInter) => {
  return service({
    url: "/api/v1/statistics/course_renew/teacher_list",
    method: "get",
    params,
  });
};
// 数据统计-续费数据-课程续费统计列表
export interface renewCourseListInter {
  start_date: string;
  end_date: string;
}
export const renewCourseListApi = (params: renewCourseListInter) => {
  return service({
    url: "/api/v1/statistics/course_renew/course_list",
    method: "get",
    params,
  });
};
// 市场数据-漏斗数据
export const marketFunnelApi = (params: {
  start_time: string;
  end_time: string;
}) => {
  return service({
    url: "/api/v1/statistics/market/funnel",
    method: "get",
    params,
  });
};
export interface marketComprehensiveInter {
  start_time: string;
  end_time: string;
  query_time: string;
  course_adviser_id?: number;
  source_id?: number;
  appear_id?: number;
}
// 数据统计-销售数据-MTD 、YTD
export const salesHitherto = () => {
  return service({
    url: "/api/v1/statistics/sales/hitherto",
    method: "get",
  });
};
export interface salesInter {
  start_time: string;
  end_time: string;
  course_adviser_id?: number;
  source_id?: number;
  appear_id?: number;
}
// 市场数据-综合数据
export const marketComprehensiveApi = (params: marketComprehensiveInter) => {
  return service({
    url: "/api/v1/statistics/market/comprehensive",
    method: "get",
    params,
  });
};
// 综合数据
export const comprehensiveApi = (params: salesInter) => {
  return service({
    url: "/api/v1/statistics/sales/comprehensive",
    method: "get",
    params,
  });
};
// 市场数据-来源渠道
export const marketCourseApi = (params: marketComprehensiveInter) => {
  return service({
    url: "/api/v1/statistics/market/source",
    method: "get",
    params,
  });
};
// 课程顾问数据
export const salesCourseAdviserApi = (params: salesInter) => {
  return service({
    url: "/api/v1/statistics/sales/course_adviser",
    method: "get",
    params,
  });
};
// 市场数据-课程顾问
export const marketCourseAdviserApi = (params: marketComprehensiveInter) => {
  return service({
    url: "/api/v1/statistics/market/course_adviser",
    method: "get",
    params,
  });
};
// 出现方式数据
export const salesAppearApi = (params: salesInter) => {
  return service({
    url: "/api/v1/statistics/sales/appear",
    method: "get",
    params,
  });
};
// 市场数据-出现方式
export const marketAppearApi = (params: marketComprehensiveInter) => {
  return service({
    url: "/api/v1/statistics/market/appear",
    method: "get",
    params,
  });
};
// 来源渠道数据
export const salesSourceApi = (params: salesInter) => {
  return service({
    url: "/api/v1/statistics/sales/source",
    method: "get",
    params,
  });
};
// 资源管理-学员阶段列表
export const studentStageApi = () => {
  return service({
    url: "/api/v1/student/stage",
    method: "get",
  });
};
// 资源管理-阶段统计
export const studentStageStatisticsApi = (
  data: statisticsStudentStageListInter
) => {
  return service({
    url: "/api/v1/statistics/student_stage/statistics",
    method: "post",
    data,
  });
};
export interface statisticsStudentStageListInter {
  page: number;
  page_size: number;
  sort_field?: string;
  sort_type?: string;
  key_word?: string;
  sex?: string[];
  student_status?: string[];
  intent_id?: number;
  source_id?: number;
  appear_id?: number;
  current_stage?: number;
  age_start?: number;
  age_end?: number;
  age_stage?: number;
  edu_teacher_id?: number;
  follow_staff_id?: number;
  create_start_time?: string;
  create_end_time?: string;
  transform_start_time?: string;
  transform_end_time?: string;
  completion_start_time?: string;
  completion_end_time?: string;
  acquisition_start_time?: string;
  acquisition_end_time?: string;
  first_visited_start_time?: string | number;
  first_visited_end_time?: string | number;
  first_experienced_start_time?: string | number;
  first_experienced_end_time?: string | number;
}
// 资源管理-学员列表
export const statisticsStudentStageListApi = (
  data: statisticsStudentStageListInter
) => {
  return service({
    url: "/api/v1/statistics/student_stage/list",
    method: "post",
    data,
  });
};

export interface statisticsStudentStageListExportInter {
  sort_field?: string;
  sort_type?: string;
  key_word?: string;
  sex?: string[];
  student_status?: string[];
  intent_id?: number;
  source_id?: number;
  appear_id?: number;
  current_stage?: number;
  age_start?: number;
  age_end?: number;
  age_stage?: number;
  edu_teacher_id?: number;
  follow_staff_id?: number;
  create_start_time?: string;
  create_end_time?: string;
  transform_start_time?: string;
  transform_end_time?: string;
  completion_start_time?: string;
  completion_end_time?: string;
  acquisition_start_time?: string;
  acquisition_end_time?: string;
  first_visited_start_time?: string | number;
  first_visited_end_time?: string | number;
  first_experienced_start_time?: string | number;
  first_experienced_end_time?: string | number;
}
// 资源管理-学员列表导出
export const statisticsStudentStageListExportApi = (
  data: statisticsStudentStageListExportInter
) => {
  return service({
    url: "/api/v1/statistics/student_stage/list_export",
    method: "post",
    data,
  });
};
export interface statisticsStudentComprehensiveInter {
  start_date: string;
  end_date: string;
  time_tag: string;
}
// 学员数据-综合数据
export const statisticsStudentComprehensiveApi = (
  params: statisticsStudentComprehensiveInter
) => {
  return service({
    url: "/api/v1/statistics/student/comprehensive",
    method: "get",
    params,
  });
};
export interface eduDataInter {
  start_date: string;
  end_date: string;
  teacher_id?: number;
  edu_teacher_id?: number;
  class_id?: number;
  subject_id?: number;
  present_status?: number; // 教师当前状态
}
// 教务数据统计
export const eduDataApi = (params: eduDataInter) => {
  return service({
    url: "/api/v1/statistics/edu_data",
    method: "get",
    params,
  });
};
// 教务数据-综合数据
export const eduListApi = (params: eduDataInter) => {
  return service({
    url: "/api/v1/statistics/edu_list",
    method: "get",
    params,
  });
};
// 教务数据-教务数据
export const eduTeacherListApi = (params: eduDataInter) => {
  return service({
    url: "/api/v1/statistics/edu_data/edu_teacher_list",
    method: "get",
    params,
  });
};
// 教务数据-授课教师数据
export const eduDataTeacherListApi = (params: eduDataInter) => {
  return service({
    url: "/api/v1/statistics/edu_data/teacher_list",
    method: "get",
    params,
  });
};
export interface eduClassListInter {
  start_date: string;
  end_date: string;
  course_type: number;
  teacher_id?: number;
  edu_teacher_id?: number;
  class_id?: number;
  subject_id?: number;
  status?: number;
}
// 教务数据-班级数据
export const eduClassListApi = (params: eduClassListInter) => {
  return service({
    url: "/api/v1/statistics/edu_data/class_list",
    method: "get",
    params,
  });
};
export interface statisticsStudentDetailInter {
  start_date: string;
  end_date: string;
  time_tag: string;
  student_id?: number;
  student_status?: number[];
  consume_status?: number;
  roll_call_status?: number;
  exceed_status?: number;
  consume_class?: number[];
  active_status?: number;
}
// 学员数据-数据明细
export const statisticsStudentDetailApi = (
  data: statisticsStudentDetailInter
) => {
  return service({
    url: "/api/v1/statistics/student/detail",
    method: "post",
    data,
  });
};
export interface eduSubjectListInter {
  start_date: string;
  end_date: string;
  teacher_id?: number;
  edu_teacher_id?: number;
  class_id?: number;
  subject_id?: number;
}
// 教务数据-科目数据
export const eduSubjectListApi = (params: eduSubjectListInter) => {
  return service({
    url: "/api/v1/statistics/edu_data/subject_list",
    method: "get",
    params,
  });
};
// 门店综合数据
export const comDataApi = (params: {
  start_date: string;
  end_date: string;
}) => {
  return service({
    url: "/api/v1/statistics/com_data",
    params,
  });
};
// 学员数据-学员结业记录列表
export const studentCompletionListApi = (data: any) => {
  return service({
    url: "/api/v1/student/completion_list",
    method: "post",
    data,
  });
};
// 学员数据-学员结业记录列表导出
export const studentCompletionListExportApi = (params: any) => {
  return service({
    url: "/api/v1/student/completion_list_export",
    method: "get",
    params,
  });
};

// 续费数据-续费数据列表
export const renewDataListApi = (params: any) => {
  return service({
    url: "/api/v1/statistics/course_renew/renew_data",
    method: "get",
    params,
  });
};

// 流失数据-流失数据列表
export const lossDataListApi = (params: any) => {
  return service({
    url: "/api/v1/statistics/completion_data",
    method: "get",
    params,
  });
};

// 学员生日统计
export const studentBirthdayStatisticsApi = (params: any) => {
  return service({
    url: "/api/v1/student/birthday_statistics",
    method: "get",
    params,
  });
};
